import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-animated-modal";

import Preloader from "../Preloader";
import OmnidoxAlert from "../Shared/OmnidoxAlert";
import DocumentTypeService from "../../services/Management/DocumentTypeService";
import DocumentSearchService from "../../services/DocumentSearch/DocumentSearchService";
import CoreConsts from "../../constants/CoreConsts";
import ServiceUrls from "../../constants/ServiceUrls";

import { ViewDocument } from "oasis-document-viewer";

import StorageSearchInput from "./StorageSearchInput";

import Filters from "./PhysicalStorage/Filters";

import DigitalSearchFilters from "./DigitalSearch/DigitalSearchFilters";
import TRSearchResult from "./PhysicalStorage/SearchResult";
import SearchResult from "./DigitalSearch/SearchResult";

const { DOCUMENTSTORE_SERVICE_URL } = ServiceUrls;

const { getDocumentTypes } = DocumentTypeService;
const {
  getPhysicalSearchFilters,
  physicalSearch,
  digitalSearch,
  getDigitalSearchSortingVariables,
  getMetadataFilterCollectionForDocumentTypes,
  getMetadataKeysSortedInDefaultPriority,
} = DocumentSearchService;

const {
  VIEW_DOCUMENT_AND_METADATA,
  SUPPORTED_IMAGE_FILE_TYPES,
  SUPPORTED_MS_OFFICE_FILE_TYPES,
  SUPPORTED_PDF_FILE_TYPES,
  SUPPORTED_PREVIEW_FILE_TYPES,
} = CoreConsts;

const pageSize = 20;

export const ITEMSCOUNTPERPAGE = 20;

const searchParameters = {
  searchCode: "",
  folderFilters: [],
  documentTypeFilters: [],
  metadataFilterCollection: {
    enumerableFilters: [],
    numeralFilters: [],
    dateFilters: [],
  },
  startingDocumentIndex: 0,
  paginatedDocumentCount: ITEMSCOUNTPERPAGE,
  accessToken: "",
  sortFieldId: 0,
  sortOrder: 0,
  enableCommentsSearching: true,
  enableOCRSearching: true,
  enableMetadataSearching: true,
};

const defaultFilters = {
  statusFilters: [],
  fbufIlters: [],
  customerFilters: [],
  departmentFilters: [],
  itemTypeFilters: [],
  sortFields: [],
};

const DIGITAL_SEARCH = "DigitalSearch";
const PHYSICAL_SEARCH = "PhysicalSearch";

export class StorageSearch extends Component {
  state = {
    searchText: "",
    DocumentTypes: [],
    physicalSearchParams: {
      pageSize: pageSize,
      pageNumber: 1,
      orderByItem: { orderBy: "ItemCode", orderType: "ASC" },
      selectedItemIds: [],
      filters: { ...defaultFilters },
    },
    isOmnidoxUser: true, //should eventually be set with User data.
    IsExpandedFilters: true,
    ActiveTab: PHYSICAL_SEARCH,
    physicalSearchResponse: { trItems: [], totalCount: 0 },
    ShowPreloader: false,
    searchParameters,
    HasError: false,
    showModal: false,
    NotificationMessage: "",
    IsEnablePhysicalSearch: false,
    IsEnableDigitalSearch: false,
    Options: { enableDigitalSearch: true, enablePhysicalSearch: true },
    DigitalSearchSortFields: [],
    isTriggeredSearch: false,
  };

  componentDidMount() {
    getMetadataKeysSortedInDefaultPriority().then((metaDefinitions) => {
      this.setState({ metaDefinitions });
    });
    this.setState(
      {
        ShowPreloader: true,
        IsEnablePhysicalSearch: this.props.User.tr_employeeId !== undefined,
        IsEnableDigitalSearch:
          this.props.User.portal_haspermission_OMNIDOX === "YES",
      },
      async () => {
        await Promise.all([
          this.props.User.portal_haspermission_OMNIDOX === "YES" &&
            getDocumentTypes(VIEW_DOCUMENT_AND_METADATA).then((res) => {
              this.setState({
                DocumentTypes: res,
                IsEnableDigitalSearch: res.length > 0,
              });
            }),
          this.getPhysicalSearchFilters(""),
        ]);

        this.setState({
          ShowPreloader: false,
          ActiveTab: this.state.IsEnablePhysicalSearch
            ? PHYSICAL_SEARCH
            : DIGITAL_SEARCH,
        });
      }
    );
  }
  getPhysicalSearchFilters = (searchText, cb) => {
    const { Options, IsEnablePhysicalSearch } = this.state;
    return IsEnablePhysicalSearch && Options.enablePhysicalSearch
      ? getPhysicalSearchFilters(searchText).then((res) => {
          if (cb) {
            cb();
          }
          this.setState({
            physicalSearchParams: {
              ...this.state.physicalSearchParams,
              filters: { ...defaultFilters, ...res },
            },
          });
        })
      : cb && cb();
  };

  changeTab = (tab) => {
    this.setState({ ActiveTab: tab });
  };

  loadMoreData = () => {
    const { searchParameters } = this.state;
    this.setState(
      {
        searchParameters: {
          ...searchParameters,
          startingDocumentIndex:
            searchParameters.startingDocumentIndex + ITEMSCOUNTPERPAGE,
        },
      },
      () => {
        this.digitalSearch(true);
      }
    );
  };

  expandFilters = () => {
    this.setState({
      IsExpandedFilters: !this.state.IsExpandedFilters,
    });
  };

  updateStateAndPhysicalSearch = (payload) => {
    const { IsEnablePhysicalSearch, Options } = this.state;

    this.setState(
      {
        ShowPreloader: IsEnablePhysicalSearch && Options.enablePhysicalSearch,
        physicalSearchParams: {
          ...this.state.physicalSearchParams,
          ...payload,
        },
      },
      () => {
        this.searchPhysicalData((res) =>
          this.setState({
            physicalSearchResponse: {
              trItems:
                this.state.physicalSearchParams.pageNumber === 1
                  ? res.trItems
                  : [
                      ...this.state.physicalSearchResponse.trItems,
                      ...res.trItems,
                    ],
              totalCount: res.totalCount,
            },
            ShowPreloader: false,
          })
        );
      }
    );
  };

  updateState = (payload) => {
    this.setState({ ...this.state, ...payload });
  };

  getSearchParams = () => {
    const { filters, selectedItemIds, ...rest } =
      this.state.physicalSearchParams;
    const { sortFields, ...restFilters } = filters;
    return {
      ...rest,
      ...restFilters,
      searchText: this.state.searchText,
    };
  };

  searchPhysicalData = (cb) => {
    const { IsEnablePhysicalSearch, Options } = this.state;

    if (IsEnablePhysicalSearch && Options.enablePhysicalSearch) {
      return physicalSearch(this.getSearchParams()).then((res) => {
        cb(res);

        if (res.searchResult === 1) {
          const host = window.location.hostname;
          let bridgeApp = "https://testbridge.oasisgroup.com/dhsrmweb";

          if (
            host === "clienthub.oasisgroup.com" ||
            host === "hub.omnidox5.com"
          ) {
            bridgeApp = "https://oasisbridge.oasisgroup.com/dhsrmweb";
          }

          const link = document.createElement("a");
          link.setAttribute(
            "href",
            `${bridgeApp}/index.html?${this.props.User["user-email"]}`
          );
          link.target = "_blank";
          link.click();
        }
        this.setState({ isTriggeredSearch: true });
      });
    } else {
      this.setState({
        physicalSearchResponse: { trItems: [], totalCount: 0 },
      });
    }
  };

  updateDigitalFilters = (payload, onUpdated) => {
    const { searchParameters, DocumentTypes } = this.state;
    const { metadataFilterCollection } = searchParameters;
    searchParameters.startingDocumentIndex = 0;
    if (payload.filterType === "document-type") {
      const docTypefilter = DocumentTypes.find((f) => f.id === payload.id);
      if (docTypefilter) {
        if (payload.isPartOfSearch) {
          searchParameters.documentTypeFilters = [
            ...searchParameters.documentTypeFilters,
            payload.id,
          ];
        } else {
          searchParameters.documentTypeFilters =
            searchParameters.documentTypeFilters.filter(
              (f) => f !== payload.id
            );
        }
        docTypefilter.isPartOfSearch = payload = payload.isPartOfSearch;
        this.setState(
          { searchParameters }
          //, () => {
          // return this.digitalSearch(onUpdated);}
        );
      }

      if (payload.setAllFilters) {
        searchParameters.documentTypeFilters = payload.isPartOfSearch
          ? DocumentTypes.map((d) => d.id)
          : [];
        this.setState({ searchParameters, ShowPreloader: true }, () => {
          return this.digitalSearch(onUpdated);
        });
      }

      if (searchParameters.documentTypeFilters.length > 0) {
        getMetadataFilterCollectionForDocumentTypes(
          searchParameters.documentTypeFilters
        ).then((metadataFilterCollection) =>
          this.setState({
            searchParameters: {
              ...searchParameters,
              metadataFilterCollection,
            },
          })
        );
      }
    } else if (payload.filterType === "metadata") {
      Object.keys(metadataFilterCollection).forEach((filterTypeKey) => {
        const metadataFilter = metadataFilterCollection[filterTypeKey].find(
          (f) => f.alias === payload.alias
        );
        if (metadataFilter) {
          metadataFilter.includedInSearch = payload.includedInSearch;
          this.setState({ searchParameters, ShowPreloader: true }, () => {
            return this.digitalSearch(onUpdated);
          });
        }
      });
    } else {
      this.setState(
        { searchParameters: { ...searchParameters, ...payload } },
        () => {
          return this.digitalSearch(onUpdated);
        }
      );
    }
  };

  digitalSearch = async (isAsync) => {
    const { searchParameters, searchEnsemble, Options, IsEnableDigitalSearch } =
      this.state;

    if (!isAsync) this.setState({ ShowPreloader: true });

    if (IsEnableDigitalSearch && Options.enableDigitalSearch) {
      return digitalSearch(searchParameters)
        .then((response) => {
          response.documents = response.documents.map((d, i) => {
            d.index = searchParameters.startingDocumentIndex + 1 + i;
            return d;
          });
          this.setState({
            ...this.state,
            HasError: false,
            searchEnsemble:
              searchParameters.startingDocumentIndex === 0
                ? response
                : {
                    ...response,
                    documents: [
                      ...searchEnsemble.documents,
                      ...response.documents,
                    ],
                  },
          });
          this.setState({ isTriggeredSearch: true });
          getDigitalSearchSortingVariables(
            searchParameters.documentTypeFilters
          ).then((res) => {
            this.setState({ DigitalSearchSortFields: res });
          });
          if (!isAsync) this.setState({ ShowPreloader: false });
        })
        .catch((err) => {
          this.setState({ IsEnableDigitalSearch: false });
        });
    } else {
      this.setState({ searchEnsemble: { totalDocumentCount: 0 } });
      if (!isAsync) this.setState({ ShowPreloader: false });
    }
  };

  searchAll = async () => {
    this.setState(
      {
        ShowPreloader: true,
        physicalSearchParams: {
          ...this.state.physicalSearchParams,
          pageNumber: 1,
          selectedItemIds: [],
          // filters: { ...defaultFilters },
        },
      },
      async () => {
        console.log(this.state);
        await Promise.all([
          this.digitalSearch(true),
          this.searchPhysicalData((res) => {
            this.setState({
              physicalSearchResponse: { ...res },
            });
          }),
        ]);
        this.getPhysicalSearchFilters(this.state.searchText, () => {
          this.setState({
            ShowPreloader: false,
          });
        });
      }
    );
  };

  checkForMetadataFilters = () => {
    const { metadataFilterCollection } = this.state.searchParameters;

    for (const key in metadataFilterCollection) {
      if (
        metadataFilterCollection[key] &&
        metadataFilterCollection[key].length > 0
      )
        return true;
    }

    return false;
  };

  render() {
    const {
      searchParameters,
      ActiveTab,
      physicalSearchResponse,
      searchText,
      searchEnsemble,
      DocumentTypes,
      metaDefinitions,
      selectedDocument,
    } = this.state;
    const { trItems, totalCount } = physicalSearchResponse;
    const _ = this.props._;

    return (
      <>
        <div className="storage-search-wrapper ml-3 mr-3">
          {this.state.ShowPreloader && <Preloader />}
          <div>
            <h2>{_.ClientHub.StorageSearch}</h2>
          </div>
          <div className="d-flex search-area">
            <StorageSearchInput
              search={this.searchAll}
              updateParentState={this.updateState}
              searchParameters={searchParameters}
              searchText={searchText}
              _={_}
              {...this.state}
            />
            <div className="d-flex search-options" onClick={this.expandFilters}>
              <p>{_.ClientHub.SearchOptions}</p>
              <div>
                <button
                  className="dropdown-toggle portlet-menu-button"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={this.expandFilters}
                >
                  {!this.state.IsExpandedFilters ? (
                    <i className="icon-omni-down-arrow"></i>
                  ) : (
                    <i className="icon-omni-up-arrow"></i>
                  )}
                </button>
              </div>
            </div>
          </div>
          {this.state.IsExpandedFilters && (
            <>
              {ActiveTab === PHYSICAL_SEARCH && (
                <Filters
                  filters={this.state.physicalSearchParams.filters}
                  updateState={this.updateState}
                />
              )}
              {ActiveTab === DIGITAL_SEARCH && DocumentTypes.length > 0 && (
                <DigitalSearchFilters
                  key={"document-type-filters-parent"}
                  updateDigitalFilters={this.updateDigitalFilters}
                  DocumentTypes={DocumentTypes}
                  searchParameters={searchParameters}
                  metadataFiltersExist={this.checkForMetadataFilters()}
                />
              )}
            </>
          )}
          <div className="d-flex justify-content-between storage-details ">
            <div className="storage-types">
              {this.state.IsEnableDigitalSearch && (
                <div
                  onClick={() => this.changeTab(DIGITAL_SEARCH)}
                  className={
                    ActiveTab === DIGITAL_SEARCH
                      ? "digital-storage active"
                      : "digital-storage"
                  }
                >
                  <h6>
                    {_.ClientHub.DigitalStorage}
                    <span className="orange-text">
                      (
                      {searchEnsemble && searchEnsemble.documents
                        ? searchEnsemble.totalDocumentCount
                        : 0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              {this.state.IsEnablePhysicalSearch && (
                <div
                  onClick={() => this.changeTab(PHYSICAL_SEARCH)}
                  className={
                    ActiveTab === PHYSICAL_SEARCH
                      ? "physical-storage active"
                      : "physical-storage"
                  }
                >
                  <h6>
                    {_.ClientHub.PhysicalStorage}
                    {trItems && (
                      <span className="orange-text">
                        ( {trItems.length} of {totalCount})
                      </span>
                    )}
                  </h6>
                </div>
              )}
            </div>
          </div>
          <div className="search-result doc-explorer">
            {ActiveTab === PHYSICAL_SEARCH && (
              <TRSearchResult
                searchResponse={physicalSearchResponse}
                updateParentState={this.updateState}
                updateStateAndPhysicalSearch={this.updateStateAndPhysicalSearch}
                physicalSearchParams={this.state.physicalSearchParams}
                searchText={this.state.searchText}
                user={this.props.User}
                isTriggeredSearch={this.state.isTriggeredSearch}
                _={_}
              ></TRSearchResult>
            )}

            {ActiveTab === DIGITAL_SEARCH && (
              <SearchResult
                searchEnsemble={searchEnsemble}
                loadMoreData={this.loadMoreData}
                updateParentState={this.updateState}
                sortFields={this.state.DigitalSearchSortFields}
                sortFieldId={searchParameters.sortFieldId}
                sortOrder={searchParameters.sortOrder}
                updateDigitalFilters={this.updateDigitalFilters}
                metaDefinitions={metaDefinitions}
                isTriggeredSearch={this.state.isTriggeredSearch}
                _={_}
              ></SearchResult>
            )}
          </div>
        </div>

        {selectedDocument && (
          <Modal
            visible={this.state.showModal}
            closemodal={() => this.setState({ showModal: false })}
            type="fadeIn"
          >
            <ViewDocument
              {...selectedDocument}
              supportedTypes={{
                SUPPORTED_IMAGE_FILE_TYPES,
                SUPPORTED_MS_OFFICE_FILE_TYPES,
                SUPPORTED_PREVIEW_FILE_TYPES,
                SUPPORTED_PDF_FILE_TYPES,
              }}
            />
          </Modal>
        )}
        {this.state.NotificationMessage && (
          <div className="notification-message">
            <OmnidoxAlert>{this.state.NotificationMessage}</OmnidoxAlert>
          </div>
        )}
      </>
    );
  }
}

export const mapStateToProps = ({ _, User }) => ({ _, User });
export default connect(mapStateToProps)(StorageSearch);
